import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';

import MobileFooter from 'base/components/MobileFooter';
import CartPageCheckoutContainer from 'cart/containers/CartPageCheckoutContainer';

class CartPageFooter extends React.Component {
  static propTypes = {
    hasItems: PropTypes.bool.isRequired
  };

  render() {
    const { hasItems } = this.props;
    if (!hasItems) {
      return null;
    }
    return (
      <MobileFooter>
        <CartPageCheckoutContainer dataTestId="mobile-checkout-button" />
      </MobileFooter>
    );
  }
}

const mapStateToProps = ({ cart }) => {
  return {
    hasItems: !!get(cart, 'items', []).length
  };
};

export default connect(mapStateToProps)(CartPageFooter);
